export enum DomainValidationMode {
    Strong = 'STRONG',
    None = 'NONE',
    Weak = 'WEAK'
  }